/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import i18n from './config/i18n-config';
export { i18nInitPromise } from './config/i18n-config';

/**
 * changeLanguage function.
 *
 * @param {*} lng - Parameter description
 *
 * @returns {*} Return value description
 */
export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
};

/**
 * getCurrentLanguage function.
 */
export const getCurrentLanguage = () => {
  return i18n.language;
};

/**
 * getAvailableLanguages function.
 */
export const getAvailableLanguages = () => {
  return ['en', 'pt-BR', 'es'];
};

export default i18n;
